import { cn } from "@/utils/css";
import type { ReactNode } from "react";

/**
 * Interface representing the props for the shared auth glass-card wrapper.
 * @interface IAuthCardProps
 * @property {ReactNode} children: Card contents.
 * @property {string} maxWidthClass: Tailwind max-width class controlling the card width (e.g. "max-w-[480px]").
 */
interface IAuthCardProps {
  children: ReactNode;
  maxWidthClass?: string;
}

const AuthCard = ({
  children,
  maxWidthClass = "max-w-[480px]",
}: IAuthCardProps) => (
  <div
    className={cn(
      "relative isolate w-full overflow-hidden rounded-3xl",
      "bg-gradient-to-br from-white/[0.08] via-white/[0.04] to-white/[0.02]",
      "backdrop-blur-2xl backdrop-saturate-150",
      "border border-white/[0.05]",
      "shadow-[0_24px_80px_rgba(0,0,0,0.5),inset_0_1px_0_rgba(255,255,255,0.08)]",
      "before:pointer-events-none before:absolute before:inset-x-0 before:top-0 before:z-[1] before:h-px before:bg-gradient-to-r before:from-transparent before:via-white/15 before:to-transparent",
      "p-8 sm:p-12",
      maxWidthClass,
    )}
  >
    <div
      aria-hidden
      className={cn(
        "-top-24 -left-24 pointer-events-none absolute z-0 h-72 w-72 rounded-full",
        "bg-dines-green/50 opacity-90 blur-[110px]",
      )}
    />
    <div
      aria-hidden
      className={cn(
        "-bottom-28 -right-20 pointer-events-none absolute z-0 h-72 w-72 rounded-full",
        "bg-indigo-500/25 opacity-80 blur-[130px]",
      )}
    />
    <div className="relative z-10">{children}</div>
  </div>
);

export default AuthCard;
